import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useTranslation } from 'react-i18next';

interface SubscriptionCardProps {
  subscriptionName: string;
}

export const SubscriptionCard = ({
  subscriptionName,
}: SubscriptionCardProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Card gap={GapEnum.M}>
      <AccentTitle
        variant={AccentVariantEnum.Accent2}
        icon="receipt-check"
        as={HeadingEnum.H2}
        text={t('delmonicos-shared-sdk.outputs-gateway-customer.subscription')}
      />
      <Tag className="bg-surface-secondary">{subscriptionName}</Tag>
    </Card>
  );
};
